import { NgModule } from '@angular/core';
import { NotificationPreferences } from './notification-preferences/notification-preferences.component';
import { PreferencesComponent } from './preferences.component';
import { DistributionPreferencesComponent } from './distribution-preferences/distribution-preferences.component';
import { PatientLinkRequestService } from '../user-relation-requests/services/patient-link-request.service';
import { SharedModule } from '../../shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { UserRelationRequestModule } from '../user-relation-requests/relation-requests.module';
import { LongOperationModule } from '../../common/long-operations/long-operations.module';

@NgModule({
  imports: [SharedModule, NgbModule, TranslateModule, UserRelationRequestModule, LongOperationModule],
  declarations: [NotificationPreferences, PreferencesComponent, DistributionPreferencesComponent],
  providers: [PatientLinkRequestService],
})
export class PreferencesModule {}
